import { render, staticRenderFns } from "./lb-table.vue?vue&type=template&id=9e6140a2"
import script from "./lb-table.vue?vue&type=script&lang=js"
export * from "./lb-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e6140a2')) {
      api.createRecord('9e6140a2', component.options)
    } else {
      api.reload('9e6140a2', component.options)
    }
    module.hot.accept("./lb-table.vue?vue&type=template&id=9e6140a2", function () {
      api.rerender('9e6140a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/lb-table/lb-table.vue"
export default component.exports